import { render, staticRenderFns } from "./zoom-basic-intro-card.vue?vue&type=template&id=74a5704b&scoped=true"
import script from "./zoom-basic-intro-card.vue?vue&type=script&lang=js"
export * from "./zoom-basic-intro-card.vue?vue&type=script&lang=js"
import style0 from "./zoom-basic-intro-card.vue?vue&type=style&index=0&id=74a5704b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a5704b",
  null
  
)

export default component.exports